import { getI18n } from "react-i18next";
import { iTxt } from "@duosoftbg/nacid-components";

export const mainHeaders = (
  t: (key: string) => string,
  countryData: any,
  isMainHeaderCellHide: (index: number) => boolean,
) => [
  isMainHeaderCellHide(0)
    ? t("t.qualCompare.mainH.level.short")
    : `${t("t.qualCompare.mainH.level")}${iTxt(getI18n().language, countryData.country?.name, countryData.country?.nameEn)}`,
  isMainHeaderCellHide(1)
    ? t("t.qualCompare.mainH.subLevel.short")
    : `${t("t.qualCompare.mainH.subLevel")}${iTxt(getI18n().language, countryData.country?.name, countryData.country?.nameEn)}`,
];

export const sideHeaders = (t: (key: string) => string, isSideHeaderCellHide: (index: number) => boolean) => [
  isSideHeaderCellHide(0) ? t("t.qualCompare.sideH.levelEQF.short") : t("t.qualCompare.sideH.levelEQF"),
  isSideHeaderCellHide(1) ? t("t.qualCompare.sideH.levelBC.short") : t("t.qualCompare.sideH.levelBC"),
  isSideHeaderCellHide(2) ? t("t.qualCompare.sideH.levelBG.short") : t("t.qualCompare.sideH.levelBG"),
];

export const subHeaders1 = (t: (key: string) => string) => [
  t("t.qualCompare.subH.level"),
  t("t.qualCompare.subH.levelNative"),
  t("t.qualCompare.subH.credits"),
  t("t.qualCompare.subH.duration"),
];
export const subHeaders2 = (t: (key: string) => string) => [
  t("t.qualCompare.subH.degree"),
  t("t.qualCompare.subH.degreeNative"),
  t("t.qualCompare.subH.credits"),
  t("t.qualCompare.subH.duration"),
];

export const tooltipMainHeader = (t: (key: string) => string, countryData: any) => [
  `${t("t.qualCompare.mainH.level")}${iTxt(getI18n().language, countryData.country?.name, countryData.country?.nameEn)}`,
  `${t("t.qualCompare.mainH.subLevel")}${iTxt(getI18n().language, countryData.country?.name, countryData.country?.nameEn)}`,
];

export const tooltipSideHeader = (t: (key: string) => string) => [
  t("t.qualCompare.sideH.levelEQF"),
  t("t.qualCompare.sideH.levelBC"),
  t("t.qualCompare.sideH.levelBG"),
];

export const mainHeadersV = (t: (key: string) => string, countryData: any, isHide: boolean) => [
  isHide
    ? t("t.qualCompare.mainH.level.short")
    : `${t("t.qualCompare.mainH.level")}${iTxt(getI18n().language, countryData.country?.name, countryData.country?.nameEn)}`,
  isHide
    ? t("t.qualCompare.mainH.subLevel.short")
    : `${t("t.qualCompare.mainH.subLevel")}${iTxt(getI18n().language, countryData.country?.name, countryData.country?.nameEn)}`,
];

export const sideHeadersV = (t: (key: string) => string, isHide: boolean) => [
  isHide ? t("t.qualCompare.sideH.levelEQF.short") : t("t.qualCompare.sideH.levelEQF"),
  isHide ? t("t.qualCompare.sideH.levelBC.short") : t("t.qualCompare.sideH.levelBC"),
  isHide ? t("t.qualCompare.sideH.levelBG.short") : t("t.qualCompare.sideH.levelBG"),
];

export const eqfLevelNumberH = [8, 7, 6];
export const eqfLevelNumberV = [6, 7, 8];
